<template>
  <main class = "main mainSales">
    <mdb-row class = "justify-content-center pb-5 subMenu">
      <mdb-col col = "auto" class = "active">Все</mdb-col>
      <mdb-col col = "auto">Для лица</mdb-col>
      <mdb-col col = "auto">Для тела</mdb-col>
      <mdb-col col = "auto">Для ног</mdb-col>
      <mdb-col col = "auto">Для волос</mdb-col>
    </mdb-row>
    <div class = "bodyFilter">
      <div class = "filter d-flex justify-content-lg-between flex-column flex-lg-row">
        <div class = "toggleFilter"><i class = "fas fa-filter" @click = "viewToggleFilter"></i></div>
        <div class = "navFilter" id = "toggleMenuFilter">
          <div class = "itemFilter">
            <div class = "selected">
              <select class = "select">
                <option selected disabled = "disabled">Назначение</option>
                <option value = "Восстановление">Восстановление</option>
                <option value = "Защита">Защита</option>
                <option value = "Массаж">Массаж</option>
                <option value = "Омоложение">Омоложение</option>
                <option value = "Очищение">Очищение</option>
                <option value = "Питание">Питание</option>
                <option value = "Противовоспалительное">Противовоспалительное</option>
                <option value = "Согревание">Согревание</option>
                <option value = "Увлажнение">Увлажнение</option>
              </select>
            </div>
          </div>
          <div class = "itemFilter">
            <div class = "selected">
              <select class = "select">
                <option selected disabled = "disabled">Группа товаров</option>
                <option value = "Бальзам">Бальзам</option>
                <option value = "Воск">Воск</option>
                <option value = "Гель">Гель</option>
                <option value = "Гель-пена">Гель-пена</option>
                <option value = "Гель-пенка">Гель-пенка</option>
                <option value = "Гидроактиватор">Гидроактиватор</option>
                <option value = "Глина">Глина</option>
                <option value = "Кондиционер">Кондиционер</option>
                <option value = "Кондиционер сухой">Кондиционер сухой</option>
                <option value = "Кондиционер тонирующий">Кондиционер тонирующий</option>
                <option value = "Концентрант">Концентрант</option>
              </select>

            </div>
          </div>
          <div class = "itemFilter">
            <div class = "selected">
              <select class = "select">
                <option selected disabled = "disabled">Бренд</option>
                <option value = "CHI">CHI</option>
                <option value = "kosmoteros">KOSMOTEROS</option>
                <option value = "lingot">LINGOT</option>
              </select>
            </div>
          </div>
        </div>
        <div class = "sorted">
          <div class = "itemSorted">
            <div class = "search">
              <input type = "search" class = "select"
                     placeholder = "Поиск" pattern = "[A-Za-zА-Яа-я0-9]{}"
                     title = "Используйте только буквы и цифры"
                     autocomplete = "on"/>
              <a><img src = "../assets/image/img/search.png" alt = "search"></a>
            </div>

          </div>
          <div class = "itemSorted">
            <div class = "selected">
              <select class = "select">
                <option value = "" selected>Порядок: по умолчанию</option>
                <option value = "price:asc">Цена: по возрастанию</option>
                <option value = "price:desc">Цена: по убыванию</option>
                <option value = "title:asc">Название: А — Я</option>
                <option value = "title:desc">Название: Я — А</option>
                <option value = "created:desc">Порядок: сперва новые</option>
                <option value = "created:asc">Порядок: сперва старые</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class = "valueSearch">Найдено {{products.length}}</div>
      </div>
    </div>
    <mdb-row>
      <mdb-col xl = "4" sm = "6" class = "mb-3 mb-md-5"
               v-for = "(product) in products"
               :key = "product.uid">
        <Card :productData = "product"
              @ModalSale = "onModalSale"
        />
      </mdb-col>
    </mdb-row>
    <ModalMoreInfo v-if = "modalData.relatedIn"
                   :modalData = "modalData"
                   @hideModal = "offModalSale"
    />
  </main>
</template>

<script>

  import Card from '@/components/Card'
  import ModalMoreInfo from '@/components/ModalMoreInfo';
  import {mdbCol, mdbRow,} from 'mdbvue';
  import {mapActions, mapGetters} from 'vuex';

  export default {
    name: "Sales",
    components: {
      mdbCol,
      mdbRow,
      Card,
      ModalMoreInfo
    },
    data() {
      return {
        modalData: {
          relatedIn: false,
          productDataId: 0,
        }
      }
    },
    computed: {
      ...mapGetters([
        'products'
      ])
    },

    mounted() {

      // Create a condition that targets viewports at least 513px wide
      const filterMenu = window.matchMedia("(min-width: 513px)");

      function filterMenuHandleTabletChange(e) {
        // Check if the media query is true
        if (e.matches) {
          let toggleMenu = document.getElementById('toggleMenuFilter');
          if (toggleMenu.classList.contains('activeFilter')) {
            toggleMenu.classList.remove('activeFilter');
          }
        }
      }

      // Register event listener
      filterMenu.addListener(filterMenuHandleTabletChange);
      // Initial check
      filterMenuHandleTabletChange(filterMenu);
    },
    methods: {
      ...mapActions(['selectProductCard']),
      onModalSale(data) {
        this.modalData = data;
        this.selectProductCard(data.productDataId);

      },
      offModalSale(data) {
        this.modalData = data;
      },
      viewToggleFilter() {
        toggleMenuFilter.classList.toggle('activeFilter');
      },
    },
  }
</script>

<style lang = "scss">

</style>
